import { ObjectDb } from './object.db';
import { PersonGridItemObject } from '@it2go/types';
import { personInfoFrag } from '../../utils/type/person.common-type';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PersonDb extends ObjectDb<PersonGridItemObject> {

    public tableName = 'person';

    protected override indices = ['id'];

    protected override columnMap = {
        serviceId: 'folders.serviceId',
        status: '$.folder.status',
    };

    protected override joins = {
        folder: 'folders.id',
    };

    protected gqlMethod = 'getPersons';

    protected syncFragment = `
        ${personInfoFrag}
        updatedAt
        folders {
            id
            serviceId
            deletedAt
        }
    `;

    protected override postProcessSyncItems(items: PersonGridItemObject[]): PersonGridItemObject[] {
        items = super.postProcessSyncItems(items);
        items.forEach((it) => {
            for (let i = it.folders.length - 1; i >= 0; i--) {
                if (it.folders[i].deletedAt) {
                    it.folders.splice(i, 1);
                }
            }
        });

        return items;
    }

}
